import React, { useEffect, useState } from 'react';
import Text from './../Text/Text';
import Paragraph from './../Paragraph/Paragraph';
import Quote from './../Quote/Quote';
import Link from './../Link/Link';
import Heading from './../Heading/Heading';
import ListItem from '../List/ListItem';
import List from '../List/List';
import ArticleImage from '@/components/ArticleImage/ArticleImage';
import Code from '../Code/Code';
import { isMobile as isMobileUtils } from '../../utils/isMobile';
import Video from '../Video/Video';
import YoutubeVideoWrapper from '../YoutubeVideoWrapper/YoutubeVideoWrapper';
import { SliderComponent } from '../SliderComponent/SliderComponent';

const anchorRegex = /(?<name>\[\#[\S]*)/gi;
type Media = {
  desktop: null | [];
  mobile: null | [];
};

type ContentProps = {
  content: [];
  images: Media;
  videos: Media;
  originUrl: string;
};

function renderer(
  item: any,
  images: any,
  videos: any,
  isMobile: boolean,
  originUrl: string,
  index: any
) {
  const children = item.children
    ? item.children.map((child: {}, indx: number) => {
        return renderer(child, images, videos, isMobile, originUrl, `${index}-${indx}`);
      })
    : null;

  switch (item.type) {
    case 'text': {
      if (item.text.includes('[VIDEOS') && videos) {
        const videoText = item.text.trim();
        const indexVideo = +videoText.at(-2) - 1;
        const video = isMobile
          ? (videos.mobile && videos?.mobile[indexVideo]) ||
            (videos.desktop && videos?.desktop[indexVideo]) ||
            null
          : (videos.desktop && videos.desktop[indexVideo]) || null;

        return video ? <Video key={item.type + indexVideo} item={video} /> : null;
      }
      if (item.text.includes('<iframe')) {
        return <YoutubeVideoWrapper key={item.text + index} iframe={item.text} />;
      }

      if (item.text.includes('[IMAGES') && images) {
        const text = item.text.trim();
        if (item.text.includes(',')) {
          const allImagesTextList = text.replace(/[\[\] ]/g, '').split(',');
          const indexes = allImagesTextList.map((el: string) => Number(el.at(-1)));

          return (
            <SliderComponent autoplay infinite>
              {indexes.map((ind: number) => (
                <ArticleImage key={item.type + ind} item={images?.desktop[ind - 1]} />
              ))}
            </SliderComponent>
          );
        } else {
          const indexImage = +text.substring(7, text.length - 1) - 1;
          const image = isMobile
            ? (images.mobile && images?.mobile[indexImage]) ||
              (images.desktop && images?.desktop[indexImage]) ||
              null
            : (images.desktop && images.desktop[indexImage]) || null;

          return image && <ArticleImage key={item.type + indexImage} item={image} />;
        }
      }

      const anchorMatch = item.text.match(anchorRegex);

      if (anchorMatch) {
        const id = anchorMatch[0].slice(2, anchorMatch[0].length - 1);

        return <span key={item.type + index} id={id}></span>;
      }

      return <Text key={item.type + index} item={item} />;
    }
    case 'paragraph': {
      const isMedia = children.some((child: any) => {
        return (
          child?.type?.name === 'Image' ||
          child?.type?.name === 'Video' ||
          child?.props?.iframe ||
          child?.props?.autoplay
        );
      });
      return isMedia ? (
        children
      ) : (
        <Paragraph key={item.type + index} item={item}>
          {children}
        </Paragraph>
      );
    }
    case 'quote': {
      return (
        <Quote key={item.type + index} item={item}>
          {children}
        </Quote>
      );
    }
    case 'link': {
      let isExternal = false;

      if (item.url.startsWith('http') && !item.url.includes(originUrl)) {
        isExternal = true;
      }

      return (
        <Link key={item.type + index} item={item} isExternal={isExternal}>
          {children}
        </Link>
      );
    }
    case 'heading': {
      return (
        <Heading key={item.type + index} item={item}>
          {children}
        </Heading>
      );
    }
    case 'list-item': {
      return (
        <ListItem key={item.type + index} item={item}>
          {children}
        </ListItem>
      );
    }
    case 'list': {
      return (
        <List key={item.type + index} item={item}>
          {children}
        </List>
      );
    }
    case 'image': {
      return <ArticleImage key={item.type + index} item={item} />;
    }
    case 'code': {
      return (
        <Code key={item.type + index} item={item}>
          {children}
        </Code>
      );
    }
    default:
      break;
  }
}
export function Content({ content, images, videos, originUrl }: ContentProps) {
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    setMobile(isMobileUtils());
  }, []);

  return content ? (
    <div>
      {content.map((item, index) => renderer(item, images, videos, mobile, originUrl, index))}
    </div>
  ) : null;
}
